// // 测试
// const VUE_APP_WS_URL = 'ws://121.196.205.21:8080/websocket';
// const VUE_APP_BASEURL = 'http://121.196.205.21:8080';

// 正式
// const VUE_APP_WS_URL = 'wss://www.saxtrader.net/websocket';
// const VUE_APP_BASEURL = 'https://www.saxtrader.net';
// const VUE_APP_WS_URL = 'wss://www.galaxytrader.cloud/websocket';
// const VUE_APP_BASEURL = 'https://www.galaxytrader.cloud';
const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
const VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || `${wsProtocol}://${window.location.host}/websocket`;
//const VUE_APP_WS_URL = 'ws://127.0.0.1:9089/websocket';
// const VUE_APP_WS_URL = 'ws://http://192.168.3.9:8080/websocket';
const VUE_APP_BASEURL = process.env.VUE_APP_API_BASE_URL || window.location.origin;
//const VUE_APP_BASEURL = 'http://127.0.0.1:9089';
// const VUE_APP_BASEURL = 'http://192.168.3.9:8080';
// 测试
// const VUE_APP_WS_URL = 'ws://103.234.54.7:8080/websocket';//测试
// const VUE_APP_BASEURL = 'http://103.234.54.7:8080';//测试
// 本地
// const VUE_APP_BASEURL = 'https://u798377y57.zicp.fun';

// 仅允许钱包登录
const JUST_WALLET = true

export { VUE_APP_WS_URL, VUE_APP_BASEURL, JUST_WALLET };
